<template>
  <div>
    <div class="back" @click="back">
      <i></i>
      <span>返回</span>
    </div>
    <div class="stepcontent">
      <div
        class="stepitem"
        v-for="(item, index) in progressbartitle"
        :key="index"
        :class="{ steptwo: !(index <= isActive) }"
      >
        <span>{{ index + 1 }}{{ item }}</span>
      </div>
    </div>
    <div class="konghuang"></div>
    <keep-alive>
      <component :is="coms" :cutcoms="cutcoms"></component>
    </keep-alive>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: 0,
      reqfrom: {
        vUrl: "",
        VideoName: "",
        VideoExplain: "",
        Format: "",
        FileSize: "",
        BeginTime: "",
        EndTime: "",
        OperatUserID: JSON.parse(localStorage.getItem("userlist")).userID,
        userArr: "",
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
        _examID: "",
        floorTime: 0, // 视频学习时长
      },
      progressbartitle: [
        //当这个length等于5的时候，就可以对进度条进行控制了。
        ".上传视频",
        ".考生管理",
      ],
      surplus: "", // 视频可用容量
    };
  },
  components: {
    Pageone: () => import("./first.vue"),
    pageTwoo: () => import("./twoo.vue"),
  },
  computed: {
    coms() {
      switch (this.isActive) {
        case 0:
          return "Pageone";
        case 1:
          return "pageTwoo";
      }
      return "ss";
    },
    fiveselect3() {
      if (this.progressbartitle.length === 5 && this.isActive == 1.3) {
        return true;
      } else {
        return false;
      }
    },
    fiveselect4() {
      if (this.progressbartitle.length === 5 && this.isActive == 2) {
        return true;
      } else {
        return false;
      }
    },
    fiveselect5() {
      if (this.progressbartitle.length === 5 && this.isActive == 3) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    setExamPage(e) {
      this.examPage = e;
    },
    setSoftApp(e) {
      this.softApp = e;
    },
    setExamValue(e) {
      this.ExamValue = e;
    },
    cutcoms(index) {
      this.isActive = index;
    },
    back() {
      if (this.$route.query.trainId) {
        // 培训过来的
        this.$router.push({
          path: "manage",
          query: {
            trainId: this.$route.query.trainId,
          },
        });
      } else {
        this.$parent.cutcoms(0);
      }
      this.$destroy();
    },
    // 试卷组卷
    changetestmode(a, b, c) {
      this.testname = a;
      this.testmode = b;
      this.checkmode = c;
    },
    addweighttest() {
      this.progressbartitle.splice(2, 0, ".范围权重设置");
    },
  },
  created() {
    this.surplus = this.$parent.surplus; // 剩余可用容量
    if (this.$route.query.trainId) {
      this.progressbartitle.pop();
    }
  },
};
</script>

<style lang="scss" scoped>
.back {
  border-bottom: 1px solid #f8f8f8;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    //  background-color: aqua;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
.stepcontent {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 88px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  // border-radius: 20% !important;
  background-color: #fff;
}
.stepitem {
  height: 45px;
  background-color: #1890ff;
  border-radius: 45px 45px 45px 45px;
  overflow: hidden;
  position: relative;
  &:nth-child(1) {
    transform: translate(90px);
    z-index: 20;
    &::before {
      background-color: #1890ff;
    }
  }
  &:nth-child(2) {
    transform: translate(45px);
    z-index: 10;
  }
  &:nth-child(3) {
    //transform: translate(45px);
    z-index: 5;
  }
  &:nth-child(4) {
    transform: translate(-45px);
    z-index: 1;
  }
  &:nth-child(5) {
    transform: translate(-90px);
    z-index: 0.5;
  }
  &::before {
    display: inline-block;
    position: absolute;
    content: "";
    width: 60px;
    height: 60px;
    background-color: rgb(255, 255, 255);
    border-radius: 50% 50%;
    transform: translate(-8px, -7px);
  }
  span {
    display: inline-block;
    width: 100%;
    line-height: 45px;
    text-align: center;
    font-size: 16px;
    font-family: PingFang SC;
    // font-weight: bold;
    color: #ffffff;
    padding-left: 71px;
    padding-right: 71px;
  }
}
.konghuang {
  height: 24px;
  background-color: #f8f8f8;
}
.steptwo {
  background-color: #eeeeee;
  span {
    color: #bbbbbb !important;
  }
}
.isstepitem3 {
  > :nth-child(3) {
    background-color: #1890ff;
    > span {
      color: rgb(255, 255, 255) !important;
    }
  }
}
.isstepitem4 {
  > :nth-child(4) {
    background-color: #1890ff;
    > span {
      color: rgb(255, 255, 255) !important;
    }
  }
}
.isstepitem5 {
  > :nth-child(5) {
    background-color: #1890ff;
    > span {
      color: rgb(255, 255, 255) !important;
    }
  }
}
</style>